import 'bootstrap/dist/css/bootstrap.min.css';
import app from './init.js';

app();
